import React, { ReactNode } from 'react';
import {
  FooterActionsContainer,
  FooterContainer,
  FooterDescription,
  FooterPrice,
  kapitalBankButtonStyles
} from './styled';
import useScreenSize from '../../../../hooks/useScreenSize';
import { KapitalbankButton } from '../../Sections/KapitalbankButton';
import { BottomPhoneButton } from '../../BottomPhoneButton';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';

interface GalleryFooterProps {
  price: string;
  description?: ReactNode;
  isKapitalbankApplicable: boolean;
  isAuthor: boolean;
  phones: string[] | null;
  isShowPhones: boolean;
  onCreditCalcClick: () => void;
  setClickOnGallery: PhoneButtonClickHandler;
}

export const GalleryFooter: React.FC<GalleryFooterProps> = ({
  price,
  description,
  isKapitalbankApplicable,
  isAuthor,
  phones,
  isShowPhones,
  onCreditCalcClick,
  setClickOnGallery
}) => {
  const { isSmall } = useScreenSize();

  return (
    <FooterContainer $isKapitalbankApplicable={isKapitalbankApplicable}>
      <div className="gallery-ads-info">
        <FooterPrice tag={isSmall ? 'h2' : 'h2_new'}>{price}</FooterPrice>
        <FooterDescription tag={isSmall ? 'caption_1_new' : 'body_3'}>
          {description}
        </FooterDescription>
      </div>

      {(isKapitalbankApplicable || isShowPhones) && (
        <FooterActionsContainer
          $isKapitalbankApplicable={isKapitalbankApplicable}
        >
          {isKapitalbankApplicable && !isAuthor && (
            <KapitalbankButton
              onClick={onCreditCalcClick}
              styles={kapitalBankButtonStyles}
            />
          )}

          {isShowPhones && !isAuthor && (
            <BottomPhoneButton
              stat="product-call-btn"
              isGallery
              isIconButton
              clickHandler={setClickOnGallery}
              isAuthor={isAuthor}
              phones={phones}
            />
          )}
        </FooterActionsContainer>
      )}
    </FooterContainer>
  );
};
